// This validator takes two control names, and checks that the values match

import { AbstractControl, ValidatorFn } from "@angular/forms"

export function MatchValidator(controlName: string, confirmControlName: string): ValidatorFn {
  return (group: AbstractControl): { [key: string]: any } | null => {
    let control = group.get(controlName);
    let confirmControl = group.get(confirmControlName);

    return (control && confirmControl && control.value.trim() !== confirmControl.value.trim()) ? { "match": true } : null;
  }
}
